// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3APgl","productName":"Table_productName__tbHeW"};